<template>
  <div
    v-if="$store.getters.isLoggedIn"
    id="blog-edit"
    class="page">
    <!-- Drawer -->
    <v-navigation-drawer
      v-model="isDrawerOpen"
      width="250px"
      mobile-break-point="0"
      floating
      app>
      <div class="h-100 d-flex flex-column page-drawer">
        <div class="page-logo-container mx-auto my-5">
          <!-- DelMar Logo -->
          <router-link
            id="logo"
            to="/content">
            <img
              src="../assets/img/logo.png"
            />
          </router-link>
          <!-- / DelMar Logo -->
        </div>

        <div class="page-navigation-container d-flex flex-column flex-grow-1">
          <!-- Main Navigation -->
          <MainNavigation />
          <!-- / Main Navigation -->

          <v-spacer></v-spacer>

          <!-- Content Navigation -->
          <PreviewPublish />
          <!-- / Content Navigation -->
        </div>

        <!-- User Account Menu -->
        <UserMenu class="mt-auto" />
        <!-- User Account Menu -->
      </div>
    </v-navigation-drawer>
    <!-- / Drawer -->

    <!-- Blog Page Blog -->
    <v-content class="h-100">
      <v-toolbar
        class="my-2 page-toolbar">
        <v-app-bar-nav-icon
          class="page-drawer-toggle"
          @click="isDrawerOpen = !isDrawerOpen">
        </v-app-bar-nav-icon>

        <v-toolbar-title
          class="pl-0">
          <h4 class="d-flex align-center">
            <router-link
              class="plain"
              to="/blog/all">
              {{$store.state.user.projectName}}
            </router-link>
            <v-icon size="18px">mdi-chevron-double-right</v-icon>
            New
          </h4>
        </v-toolbar-title>
      </v-toolbar>

      <v-divider class="mx-5"></v-divider>

      <div class="page-content p-0 mx-5 mb-5">
        <BlogCreateForm />
      </div>
    </v-content>
    <!-- / Blog Page Blog -->
  </div>
</template>

<script>
import MainNavigation from '../components/MainNavigation.vue';
import PreviewPublish from '../components/PreviewPublish.vue';
import UserMenu from '../components/UserMenu.vue';
import BlogCreateForm from '../components/BlogCreateForm.vue';

export default {
  name: 'BlogNew',
  components: {
    MainNavigation,
    PreviewPublish,
    UserMenu,
    BlogCreateForm,
  },
  data() {
    return {
      isDrawerOpen: true,
    };
  },
};
</script>

<style lang="scss"></style>
